<template>
  <el-row class="card-suggest-reviews mt-4">
    <el-col class="header-card">
      <el-checkbox class="header-item" v-model="networkSuggested.checked"></el-checkbox>
      <p class="header-item" v-if="isFacebook">
        <img :src="require(`@/assets/facebook-logo-5-1.png`)" alt="Logo Facebook"
             width="22px">
      </p>
      <p class="header-item" v-if="isGoogle">
        <img :src="require(`@/assets/google-logo-carre.png`)" alt="Logo Facebook"
             width="22px">
      </p>
      <p class="header-item">
        {{ networkSuggested.name }}
        <el-tooltip class="item" effect="dark" :content="tooltipsContent" placement="top-start">
          <em class="el-icon-warning mt-1 icon-info"></em>
        </el-tooltip>
      </p>
    </el-col>
    <el-col class="body-card">
      <p class="body-item" @click="toggleForm('subject')">Objet du mail :
        {{ networkSuggested.mail.subject }}</p>
      <p v-show="isEditingContent('subject')">
        <el-input type="text" v-model="networkSuggested.mail.subject" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.mail.subject === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('subject')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>

      <p class="body-item" @click="toggleForm('sir')">{{ networkSuggested.mail.content.sir }}</p>
      <p v-show="isEditingContent('sir')">
        <el-input type="text" v-model="networkSuggested.mail.content.sir" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.mail.content.sir === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('sir')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>


      <p class="body-item" @click="toggleForm('contentMail')">
        {{ networkSuggested.mail.content.contentMail }}</p>
      <p>
      <p v-show="isEditingContent('contentMail')">
        <el-input type="textarea" v-model="networkSuggested.mail.content.contentMail" :autosize="{ minRows: 5, maxRows: 4}" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.mail.content.contentMail === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('contentMail')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
        <el-button size="small" v-if="isEditingContent && networkSuggested.mail.content.contentMail === ''"><em class="el-icon-close red-color-icon"></em>
        </el-button>
        <el-button size="small" v-show="isEditingContent" v-else @click="toggleForm('contentMail')"><em
            class="el-icon-check green-color-icon"></em></el-button>
      </p>

      <p class="body-item" @click="toggleForm('deviseMail')">{{
          networkSuggested.mail.content.deviseMail
        }}</p>
      <p v-show="isEditingContent('deviseMail')">
        <el-input type="text" v-model="networkSuggested.mail.content.deviseMail" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.mail.content.deviseMail === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('deviseMail')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>
      <p class="body-item" v-if="isFacebook" @click="toggleForm('linkMedia')">
        {{ isLinkNetworkSuggestedFacebook ? networkSuggested.link : "Aucun lien disponible actuellement."}}
      </p>
      <p class="p-10 small" v-if="isFacebook" v-show="isEditingContent('linkMedia')">
        <el-input type="text" v-model="networkSuggested.link" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.link === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('linkMedia')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>

      <p class="body-item" v-if="isGoogle" @click="toggleForm('linkMedia')">
        {{ isLinkNetworkSuggestedGoogle ? networkSuggested.link : "Aucun lien disponible actuellement."}}
      </p>
      <p class="p-10 small" v-if="isGoogle" v-show="isEditingContent('linkMedia')">
        <el-input type="text" v-model="networkSuggested.link" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.link === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('linkMedia')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>

      <p class="body-item" @click="toggleForm('sincerely')">{{
          networkSuggested.mail.content.sincerely
        }}</p>
      <p v-show="isEditingContent('sincerely')">
        <el-input type="text" v-model="networkSuggested.mail.content.sincerely" class="mb-3 mt-3 subject-suggested-reviews">
          <el-button slot="append" v-if="networkSuggested.mail.content.sincerely === ''"><em class="el-icon-close red-color-icon"></em></el-button>
          <el-button slot="append" v-else @click="toggleForm('sincerely')"><em class="el-icon-check green-color-icon"></em>
          </el-button>
        </el-input>
      </p>
    </el-col>
  </el-row>
</template>

<script>
import { $t } from '@/i18n';

export default {
  name: 'CardSuggestedReviews',
  props: {
    networkSuggested: { type: Object }
  },
  data () {
    return {
      tooltipsContent: $t('socialReviews.tooltipMessage')
    }
  },
  computed: {
    isFacebook () {
      return this.networkSuggested.name === 'Facebook'
    },
    isGoogle () {
      return this.networkSuggested.name === 'Google'
    },
    isLinkNetworkSuggestedFacebook () {
      return this.networkSuggested.name === 'Facebook' && this.networkSuggested.link !== '#' && this.networkSuggested.link !== '' && this.networkSuggested.link !== null
    },
    isLinkNetworkSuggestedGoogle () {
      return this.networkSuggested.name === 'Google' && this.networkSuggested.link !== '#' && this.networkSuggested.link !== '' && this.networkSuggested.link !== null
    }
  },
  methods: {
    isEditingContent (name) {
      return this.$store.getters.getMailContextEditing(name)
    },
    toggleForm (name) {
      return this.$store.commit('setMailContextEditing', { property: name })
    }
  }
}
</script>

<style scoped>
.card-suggest-reviews {
  padding: 10px 20px;
  border: 1px solid #D3D3D3;
  width: 400px;
}

.header-card {
  display: flex;
  justify-content: start;
  border-bottom: 1px solid #46A3B9;
}

.header-item {
  margin-right: 10px;
}

.body-item {
  margin-top: 10px;
  cursor: pointer;
}

.subject-suggested-reviews, .content-suggested-reviews {
  font-size: 15px;
}

.green-color-icon {
  color: green;
}

.red-color-icon {
  color: red;
}
.icon-info {
  color: #00b4cc;
}

</style>
